import type { Id } from 'convex/_generated/dataModel';
import type { Garden } from '@modules/garden-planner/business_logic';

export function createHandleCellSlotsChange(
  selectedGarden: Garden | null | undefined,
  setCellSlotsPerCell: (args: {
    gardenId: Id<'gardens'>;
    row: number;
    col: number;
    slotsPerCell: number;
  }) => Promise<unknown>
) {
  return async (row: number, col: number, slotsPerCell: number) => {
    if (!selectedGarden) return;
    const MAX_SLOTS = 5;
    const clamped = Math.max(1, Math.min(Math.floor(slotsPerCell), MAX_SLOTS));
    await setCellSlotsPerCell({
      gardenId: selectedGarden._id,
      row,
      col,
      slotsPerCell: clamped,
    });
  };
}

export function createHandleBulkSaveCellSettings(
  garden: Garden | null | undefined,
  bulkSelectedCells: Array<{ row: number; col: number }>,
  setBulkCellSlotsPerCell: (args: {
    gardenId: Id<'gardens'>;
    cells: Array<{ row: number; col: number }>;
    slotsPerCell: number;
  }) => Promise<unknown>
) {
  return async (slotsPerCell: number) => {
    if (!garden || bulkSelectedCells.length === 0) return;
    const MAX_SLOTS = 5;
    const clamped = Math.max(1, Math.min(Math.floor(slotsPerCell), MAX_SLOTS));
    await setBulkCellSlotsPerCell({
      gardenId: garden._id,
      cells: bulkSelectedCells,
      slotsPerCell: clamped,
    });
  };
}

export function createHandleSaveCellSettings(
  selectedCell: { row: number; col: number } | null,
  slotsPerCell: number,
  handleCellSlotsChange: (row: number, col: number, slots: number) => Promise<void>
) {
  return async () => {
    if (!selectedCell) return;
    await handleCellSlotsChange(selectedCell.row, selectedCell.col, slotsPerCell);
  };
}

export function createHandleBulkSaveWithCleanup(
  handleBulkSave: (slotsPerCell: number) => Promise<void>,
  slotsPerCell: number,
  clearBulkSelectedCells: () => void
) {
  return async () => {
    await handleBulkSave(slotsPerCell);
    clearBulkSelectedCells();
  };
}
